import { canPlayFullOrPreview } from './video-access';
import { isExternalVideo } from '../../common/ui-selectors/video/video-origin';
export const shouldFetchUrls = _ref => {
  let {
    videoUrls,
    channelData = {},
    videoItem = {},
    currentSiteUser
  } = _ref;
  return !videoUrls && !isExternalVideo(videoItem) && canPlayFullOrPreview(channelData, videoItem, currentSiteUser);
};
//# sourceMappingURL=fetch-urls.js.map